export const collectionPageDescriptionMock = 'Hier finden Sie eine Übersicht über Ihre abgespeicherten PDF-Dateien und können diese verwalten.'
